const DexpTrackingKeys = {
    PLEASE_ENTER_SEARCH_NUMBER: "pleaseEnterSearchNumber",
    RETRIEVE_SUCCESS_MESSAGE: "retrieveSuccessMessage",
    FAILED_TO_RETRIEVE_ERROR_MESSAGE: "failedToRetrieveErrorMessage",
    FAILED_TO_TRACK_ERROR_MESSAGE: "failedToTrackErrorMessage",
    CONTAINER_NO: "containerNo",
    CCN: "ccn",
    NO_RECORD_FOUND: "noRecordFound",
    VIEWING: "viewing",
    CONTAINER_HISTORY: "containerHistory",
    FOR_CUSTOMS_STATUS_PLEASE_SEARCH_BY: "forCustomsStatusPleaseSearchBy",
    CNTR: "cntr",
    VESSEL: "vessel",
    DAYS_AT_PORT: "daysAtPort",
    TITLE: "title",
    LOGIN_BUTTON: "loginButton",
    REGISTER_BUTTON: "registerButton",
    COMPLIANCE_SUMMARY_TITLE: "complianceSummaryTitle",
    MASTER_LEVEL_TITLE: "masterLevelTitle",
    PRIMARY_ACI_MANIFESTS: "primaryACIManifests",
    PRIMARY_ACI_OCEAN_MANIFEST: "primaryACIOceanManifest",
    NOTE: "note",
    HOUSE_LEVEL_TITLE: "houseLevelTitle",
    EHBLS: "ehbls",
    RELEASED: "released",
    ACCEPTED: "accepted",
    ACCEPTED_CBSA: "acceptedCBSA",
    SUBMITTED: "submitted",
    HELD: "held",
    REJECTED: "rejected",
    DATA_NOT_AVAILABLE: "dataNotAvailable",
    TIMELINE_TITLE: "timelineTitle",
    CUSTOMS_HOLD: "customsHold",
    STORAGE_CHARGE_LAST_FREE_DAY: "storageChargeLastFreeDay"
}

export default DexpTrackingKeys